import { Navigate, useNavigate } from 'react-router-dom';
import { tierById } from '@/lib/sponsor/catalog';
import { fmtDate, usd } from '@/lib/sponsor/pricing';
import { useSponsorStore } from '@/lib/sponsor/store';

export default function SponsorDonePage() {
  const store = useSponsorStore();
  const navigate = useNavigate();
  const order = [...store.orders].reverse().find((o) => o.accountId === store.currentAccountId);
  if (!order) return <Navigate to="/sponsor" replace />;

  const t = tierById(order.tier);
  const wait = order.status === 'waiting_payment';

  return (
    <div className="bg-background-50 border border-background-200 rounded-2xl px-5 py-10 flex flex-col items-center gap-4 text-center">
      <span className={`w-16 h-16 rounded-full grid place-items-center text-3xl ${wait ? 'bg-secondary-100 text-secondary-700' : 'bg-accent-100 text-accent-700'}`} aria-hidden="true">
        <i className={wait ? 'ri-time-line' : 'ri-check-line'}></i>
      </span>
      <h1 className="font-heading font-bold text-2xl">{wait ? 'Invoice sent. You are almost a sponsor.' : `Welcome, ${t.name} sponsor`}</h1>
      <p className="max-w-xl text-foreground-600">
        {wait
          ? 'Pay the invoice by bank transfer. Your dashboard is open now and your ads go live when OPS confirms the money.'
          : 'Payment received. Your dashboard is open and OPS is checking your licence and ad, usually within 1 working day.'}
      </p>
      <dl className="w-full max-w-md text-left bg-background-100 rounded-xl p-4 flex flex-col gap-2 text-sm">
        {[
          ['Order', order.no],
          ['Package', `${t.name} · ${order.months} month${order.months > 1 ? 's' : ''}`],
          [wait ? 'Invoice' : 'Paid', usd(order.total)],
          ['Runs', `${fmtDate(order.start)} to ${fmtDate(order.end)}`],
        ].map(([k, v]) => (
          <div key={k} className="flex justify-between gap-3"><dt className="text-foreground-500">{k}</dt><dd>{v}</dd></div>
        ))}
      </dl>
      <div className="grid gap-3 sm:grid-cols-3 w-full max-w-2xl text-left">
        {[
          ['1 · OPS checks your ad', 'Within 1 working day. We call if something needs fixing.'],
          ['2 · Ads go live', `In ${t.apps.length > 2 ? 'all connected apps' : t.apps.join(' and ')}.`],
          ['3 · Watch results', 'Views, taps and answers update daily on your dashboard.'],
        ].map(([h, p]) => (
          <div key={h} className="bg-background-100 rounded-xl p-3 text-sm text-foreground-500">
            <b className="block text-foreground-950">{h}</b>{p}
          </div>
        ))}
      </div>
      <button type="button" onClick={() => navigate('/sponsor/dashboard')} className="px-8 py-3 rounded-xl bg-foreground-950 text-background-50 font-bold cursor-pointer">
        Open my dashboard
      </button>
    </div>
  );
}
